import styled from '../../../theme/styled-with-theme';
import { pxToRem } from '../../../styles/utils';
import { mediaQueries } from '../../../styles/media-queries';
import { Container, Input, Button as StyledButton } from '../styles';

export const DesktopPhoneNumberWrapper = styled(Container)`
  min-width: fit-content;

  ${mediaQueries[0]} {
    max-height: ${pxToRem(48)};
    width: ${pxToRem(268)};
  }

  ${mediaQueries.min} {
    max-height: ${pxToRem(48)};
    width: ${pxToRem(268)};
  }

  ${mediaQueries.desktop} {
    max-height: ${pxToRem(48)};
    width: ${pxToRem(282)};
  }

  ${mediaQueries.max} {
    max-height: ${pxToRem(56)};
    width: ${pxToRem(356)};
  }
`;

export const PhoneNumberInput = styled(Input)`
  opacity: 1;
  flex: 1 1 auto;
  padding: ${pxToRem(20)};

  border: ${({ theme }) => `${pxToRem(1)} solid ${theme.cfColor.green}`};

  ${mediaQueries[0]} {
    height: ${pxToRem(48)};
    min-height: ${pxToRem(48)};
    width: ${pxToRem(142)};
    min-width: ${pxToRem(142)};
    border-radius: ${({ theme }) => theme.borderRadius.input_desktop};
    font-size: ${({ theme }) => theme.fontSize['2xs']};
    padding: ${({ theme }) => theme.spacing.m};

    ::placeholder {
      font-size: ${({ theme }) => theme.fontSize['2xs']};
    }
  }

  ${mediaQueries.min} {
    height: ${pxToRem(48)};
    min-height: ${pxToRem(48)};
    width: ${pxToRem(142)};
    min-width: ${pxToRem(142)};
    border-radius: ${({ theme }) => theme.borderRadius.input_desktop};
    font-size: ${({ theme }) => theme.fontSize['2xs']};
    padding: ${({ theme }) => theme.spacing.m};

    ::placeholder {
      font-size: ${({ theme }) => theme.fontSize['2xs']};
    }
  }

  ${mediaQueries.desktop} {
    height: ${pxToRem(48)};
    min-height: ${pxToRem(48)};
    width: ${pxToRem(190)};
    min-width: ${pxToRem(190)};
    border-radius: ${({ theme }) => theme.borderRadius.input_desktop};
    font-size: ${({ theme }) => theme.fontSize.s};

    ::placeholder {
      font-size: ${({ theme }) => theme.fontSize.s};
    }
  }

  ${mediaQueries.max} {
    height: ${pxToRem(56)};
    min-height: ${pxToRem(56)};
    width: ${pxToRem(211)};
    font-size: ${({ theme }) => theme.fontSize.sm};

    ::placeholder {
      font-size: ${({ theme }) => theme.fontSize.sm};
    }
  }
`;

export const PhoneNumberButton = styled(StyledButton)`
  margin-left: ${({ theme }) => theme.spacing.s};

  ${mediaQueries[0]} {
    font-size: ${({ theme }) => theme.fontSize['2xs']};
    border-radius: ${({ theme }) => theme.borderRadius.button_desktop};
    width: ${pxToRem(100)};
    min-width: fit-content;
    height: ${pxToRem(48)};
    min-height: ${pxToRem(48)};
  }

  ${mediaQueries.min} {
    font-size: ${({ theme }) => theme.fontSize['2xs']};
    border-radius: ${({ theme }) => theme.borderRadius.button_desktop};
    width: ${pxToRem(100)};
    min-width: fit-content;
    height: ${pxToRem(48)};
    min-height: ${pxToRem(48)};
  }

  ${mediaQueries.desktop} {
    font-size: ${({ theme }) => theme.fontSize.s};
  }

  ${mediaQueries.max} {
    font-size: ${({ theme }) => theme.fontSize.sm};

    width: ${pxToRem(137)};
    min-width: fit-content;
    height: ${pxToRem(56)};
    min-height: ${pxToRem(56)};
  }
`;
